import { HttpTicketReportService } from './../../../../service/http-ticket-report.service';
import { Component, OnInit } from '@angular/core';
import { TicketReportDto, WorkflowDto } from '../../../../service/dto';
import { HttpWorkflowService } from '../../../../service/http-workflow.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TicketReportRunModalComponent } from '../ticket-report-run-modal/ticket-report-run-modal.component';


interface Wrapper {
	selected: boolean;
	payload: TicketReportDto;
}
@Component({
	selector: 'app-ticket-report-list',
	standalone: false,
	templateUrl: './ticket-report-list.component.html',
	styleUrl: './ticket-report-list.component.scss'
})
export class TicketReportListComponent implements OnInit {
	workflows: WorkflowDto[] = [];
	workflow?: WorkflowDto;
	subscription = new Subscription();
	data: Wrapper[] = [];

	constructor(
		private httpService: HttpTicketReportService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private modalService: NzModalService,
		private location: Location) {

	}

	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => {
			this.workflows = result;

			this.subscription.add(this.activatedRoute.paramMap.subscribe(params => {
				const workflowId = params.get('workflowId');
				if (!workflowId) {
					this.onWorkflowChange(this.workflows[0]);
					return;
				}
				const match = this.workflows.find(w => String(w.id) === workflowId);
				this.onWorkflowChange(match ?? this.workflows[0]);
			}));
		});
	}
	onWorkflowChange(workflow: WorkflowDto) {
		this.workflow = workflow;
		this.data = workflow.reports.map(item => ({ payload: item, selected: false }));
		this.location.go(`ticket/report/${workflow.id}/list`);
	}

	compareById(i1: WorkflowDto, i2: WorkflowDto): boolean {
		if (!i1 || !i2) return false;
		return i1.id == i2.id
	}
	open(report: TicketReportDto) {
		this.router.navigate(['/ticket', 'report', report.id, 'edit']);
	}

	areAllSelected(): boolean {
		return !this.data.some(item => item.selected == false);
	}
	areSomeSelected() {
		if (this.areAllSelected()) {
			return false;
		}
		return this.data.some(item => item.selected == true);
	}
	setMultipleSelected(selected: boolean) {
		return this.data.forEach(item => item.selected = selected);
	}
	run() {
		const modalRef = this.modalService.create({
			nzTitle: 'Download Report',
			nzContent: TicketReportRunModalComponent,
			nzFooter: null
		});
		modalRef.componentInstance!.reports=this.data.map(item => item.payload);

		modalRef.afterClose.subscribe(result => {
			// if (result) {
			// 	console.log(result.endDate, result.includeSummary);
			// }
		});
	}

}
